import type { OrderDTO, QliroValidateOrderDeclineResponse } from 'ecosystem'
import { createLogger } from 'shared-utils/utils/logger'

const logger = createLogger('payment', 'qliro', 'validate')

export const validatePostnordShipping = (
  storefrontOrder: OrderDTO
): QliroValidateOrderDeclineResponse | null => {
  const postnordDetails = storefrontOrder.shippingInfo?.additionalInfo?.postnordDetails

  if (!postnordDetails) {
    logger.warn('PostNord shipping data missing on storefront order', {
      storefrontOrderId: storefrontOrder.id
    })
    return {
      DeclineReason: 'MISSING_POSTNORD_SHIPPING_DATA',
      DeclineReasonMessage: 'Shipping information is incomplete. Please select a delivery option.'
    }
  }

  if (!postnordDetails.isPickupFromStore && !postnordDetails.deliveryOption) {
    logger.warn('PostNord delivery option missing', {
      storefrontOrderId: storefrontOrder.id
    })
    return {
      DeclineReason: 'MISSING_POSTNORD_DELIVERY_OPTION',
      DeclineReasonMessage: 'Please select a delivery option before completing your purchase.'
    }
  }

  return null
}
